// extracted by mini-css-extract-plugin
export default {"property-wrapper":"Property_property-wrapper__fO34j","property-icon":"Property_property-icon__wQhbR"};